import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from "redux";
import {Link} from "react-router-dom";
import ListView from "../common/ListView";
import {searchProductStocks, getProduct} from "./actions";
import MoneyDisplay from "../common/MoneyDisplay";
import {decodeParams} from "../utils/params";
import BackButton from "../common/BackButton";

class StocksPage extends Component {
  static propTypes = {
    /* state */
    history: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    productLoading: PropTypes.bool.isRequired,
    product: PropTypes.object,
    /* actions */
    searchProductStocks: PropTypes.func.isRequired,
    getProduct: PropTypes.func.isRequired,
  };

  componentDidMount() {
    this._load();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.productId !== this.props.match.params.productId) this._load();
  }

  _load() {
    const {productId} = decodeParams(this.props.match.params);
    this.props.getProduct({productId});
  }

  render() {
    const {
      salonId, history, searchProductStocks, product, productLoading,
      search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    if (!product || productLoading) return null;
    const {productId} = product;
    const columns = [
      {
        title: 'SKU',
        dataIndex: 'sku',
        key: 'sku',
        sorter: true,
        render: (sku) => <span>{sku || '-'}</span>
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
        key: 'quantity',
        sorter: true,
      },
      {
        title: 'Lot Number',
        dataIndex: 'lotNumber',
        key: 'lotNumber',
        sorter: true,
        render: (lotNumber) => <span>{lotNumber || '-'}</span>
      },
      {
        title: 'Cost Price',
        dataIndex: 'averageNetCostPerUnit',
        key: 'averageNetCostPerUnit',
        sorter: true,
        render: (costPrice) => <MoneyDisplay amount={costPrice} decimals={5}/>
      },
      {
        title: 'Returns',
        dataIndex: 'returns',
        key: 'returns',
        sorter: true,
      },
      {
        title: 'Action',
        key: 'action',
        fixed: 'right',
        width: 180,
        render: (_, {productId, sku}) => {
          const encodedId = encodeURIComponent(productId);
          const encodedSku = encodeURIComponent(sku || '-');
          return (
            <React.Fragment>
              {product.archived ? null : <React.Fragment>
                <Link to={`/product/adjust/${encodedId}/${encodedSku}`}>Adjust</Link>
                {' | '}
                <Link to={`/product/label/${encodedId}/${encodedSku}`}>Label</Link>
                {' | '}
              </React.Fragment>}
              <Link to={`/product/batches/${encodedId}/${encodedSku}`}>Batches</Link>
            </React.Fragment>
          );
        }
      }
    ];
    return (
      <ListView
        title={[
          <BackButton key="back" history={history} />,
          ` ${product.name} Stock`
        ]}
        searchPlaceholder="Search sku and lot number"
        loading={searching}
        columns={columns}
        dataSourceProvider={(payload) => searchProductStocks({...payload, filters: {...payload.filters, productId}})}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        salonId={salonId}
        rowKey="sku"
        {...(product.archived ? {} : {
          addText: "Receive",
          onAdd: () => history.push(`/product/receive/${productId}/-`),
        })}
      />
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  product: state.product.product,
  productLoading: state.product.productLoading,
  search: state.product.stocksSearch,
});

const mapDispatchToProps = dispatch => (bindActionCreators({
  searchProductStocks,
  getProduct,
}, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(StocksPage);



// WEBPACK FOOTER //
// ./src/Product/StocksPage.js